import { render, staticRenderFns } from "./CauHoiThuongGap.vue?vue&type=template&id=1cf2fd27&scoped=true&"
import script from "./CauHoiThuongGap.vue?vue&type=script&lang=js&"
export * from "./CauHoiThuongGap.vue?vue&type=script&lang=js&"
import style0 from "./CauHoiThuongGap.vue?vue&type=style&index=0&id=1cf2fd27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf2fd27",
  null
  
)

export default component.exports